__webpack_require__.p = "https://partner-beacon.hover-static.pages.dev/";